import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import MaintenanceTaskImportGeneral from './task-import-general';
import MaintenanceTaskImportSpecific from './task-import-specific';

class MaintenanceTaskImport extends React.Component {

    static propTypes = {
      projectId: PropTypes.string,
      closeModal: PropTypes.func
    }

    constructor(props) {
      super(props);

      this.state = {
        tabs: {
          headers: [
            {name: 'General' },
            {name: 'Inventory-specific' }
          ],
          contents: [
            (<MaintenanceTaskImportGeneral projectId={this.props.projectId} />),
            (<MaintenanceTaskImportSpecific projectId={this.props.projectId} />)
          ]
        },
        activeIndex: 0
      };
    }

    componentDidMount() {
    }

    closeModal = () => {
      this.props.closeModal();
    }

    renderTabHeaders = () => {
      return (
        <div className='maintenance-schedule-tab-header' style={{borderBottom: 'none'}}>
          {
            this.state.tabs.headers.map((value, index) => {
              return (
                <button key={index} onClick={() => this.setState({activeIndex: index})}
                  className={this.state.activeIndex === index
                    ? 'radius-button-maintenance btn bn-primary btn-siteone'
                    : 'radius-button-maintenance btn btn-siteone-default'}>
                  {value.name}
                </button>
              );
            })
          }
        </div>
      );
    }

    renderTabContent = () => {
      return (this.state.tabs.contents[this.state.activeIndex]);
    }

    render() {
      return (
        <Modal centered='true' dialogClassName='import-task-modal' show={true}>
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>Suggested Maintenance Tasks</Modal.Title>
            <span className='close' onClick={this.closeModal} >&times;</span>
          </Modal.Header>
          <Modal.Body>
            <div className='maintenance-schedule-wrapper'>
              {this.renderTabHeaders()}
              {this.renderTabContent()}
            </div>
          </Modal.Body>
        </Modal>
      );
    }
}

export default MaintenanceTaskImport;



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-import.js